module.exports = __webpack_public_path__ + "img/ydzrbf2.b98fb6dc.png";